import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { InsuranceAccountReceivableRow } from "../../pages/app/provider/billings/account-receivable/insurance/AccountReceivableInsuranceTable";
import { AccountReceivableControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchString?: string;
  startDate?: string;
  endDate?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

export const useInsuranceAccountReceivable = ({
  pagination,
  gridSorting,
  searchString,
  startDate,
  endDate,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<InsuranceAccountReceivableRow> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "insurance-account-receivable",
      pageIndex,
      pageSize,
      gridSorting,
      searchString,
      startDate,
      endDate,
      xTENANTID,
      sortData,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled,
    queryFn: async () =>
      await new AccountReceivableControllerApi(getConfigObject())
        .getInsuranceAccountReceivable(
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, //sortDirection
          searchString,
          startDate,
          endDate,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
